import './index.scss'
import text from './text.json'
import {PageSubTitle, PageTitle} from '../../components/core/title'
import ResponsivePageTitle from '../../components/core/title/ResponsivePageTitle'
import Footer from '../../components/layouts/footer'
import Table from '../../components/core/table'
import ContentLoader from '../../components/core/loader'
import {
    AmexCardIcon,
    CardIcon,
    DiscoverCardIcon,
    GooglePayIcon,
    LinkPaymentIcon,
    MasterCardIcon,
    StripeIcon,
    VisaCardIcon
} from '../../icons'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getPaymentMethods} from '../../stores/payment'
import DateHelper from './../../utils/date'
import {useNavigate} from 'react-router-dom'
import {routes} from '../../routes'
import classNames from 'classnames'
import EmptyContent from '../resources/EmptyContent'
import TextHelper from '../../utils/text'

const PaymentMethods = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const paymentMethodsData = useSelector(state => state.payment.paymentMethods)
    const isFetching = useSelector(state => state.payment.isFetching)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const paymentMethods = paymentMethodsData?.data?.payment_methods || []
    const sortedData = [].concat(paymentMethods).sort((a, b) => a.created_at < b.created_at ? 1 : -1)
    const tableHeader =  [
        {
            label: 'Type',
            className: 'min-width'
        },
        {
            label: '',
            className: 'min-width'
        },
        {
            label: 'Details',
            className: 'min-width'
        },
        {
            label: 'Expires',
            className: 'min-width'
        },
        {
            label: 'Provider',
            className: 'min-width'
        }
    ]

    const tbodyData = []

    const cardIcons = {
        mastercard: <MasterCardIcon className="card-icon"/>,
        visa: <VisaCardIcon className="card-icon"/>,
        amex: <AmexCardIcon className="card-icon"/>,
        discover: <DiscoverCardIcon className="card-icon"/>
    }

    const paymentMethodsIcons = {
        card: {
            name: 'Card',
            icon: <CardIcon className="table-icon"/>
        },
        link: {
            name: 'Link',
            icon: <LinkPaymentIcon />
        },
        google_pay: {
            name: 'Google pay',
            icon: <GooglePayIcon className="filled-icon"/>
        }
    }

    const returnPaymentType = type => {
        return <span className="min-width">
            <span className="payment-type">
                {paymentMethodsIcons[type]?.icon}
                <span>{paymentMethodsIcons[type]?.name || TextHelper.capitalizeFirstChar(type)}</span>
            </span>
        </span>
    }

    const returnPaymentDetails = details => {
        return (
            <span className="details">
                {cardIcons[details.brand]}
                <span>{`•••• ${details.last_4}`}</span>
            </span>
        )
    }

    const returnPaymentExpires = details => {
        return (
            <span className="details">
                <span>{`${DateHelper.addZero(details.exp_month)}/${details.exp_year}`}</span>
            </span>
        )
    }

    useEffect(() => {
        dispatch(getPaymentMethods())
    }, [])

    sortedData?.map(item => {
        tbodyData.push([
            returnPaymentType(item?.type),
            <span className="min-width">{item?.is_default && <span className="default">{text.default}</span>}</span>,
            <span className="min-width">{item?.details ? returnPaymentDetails(item?.details) : text.not_available}</span>,
            <span className="min-width">{item?.details ? returnPaymentExpires(item?.details) : text.not_available}</span>,
            <span className="min-width">{<StripeIcon className="card-icon"/>}</span>
        ])
    })
    return (
        <main className={classNames('main payment-methods', {
            dark: isDarkMode
        })}>
            <div>
                <div>
                    <ResponsivePageTitle/>
                    <div className="content-title">
                        <div className="left-side">
                            <div>
                                <PageSubTitle>
                                    <p className={classNames('section', {
                                        dark: isDarkMode
                                    })}>{text.section}</p>
                                </PageSubTitle>
                                <PageTitle>
                                    <h1  className={classNames('page-title', {
                                        dark: isDarkMode
                                    })}>{text.title}</h1>
                                </PageTitle>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    isFetching ? <ContentLoader/> : (
                        paymentMethods?.length !== 0 ? (
                            <div className="content-body">
                                <Table
                                    tableHeader={tableHeader}
                                    tbodyData={tbodyData}
                                    data={sortedData}
                                    hasCheckbox={false}
                                    isMultiCheckable={false}
                                />
                            </div>) : (
                            <EmptyContent
                                message={text?.no_payment_methods}
                                hideButton={false}
                                buttonText={text.plans}
                                showIcon={false}
                                onclick={() => navigate(routes.plans.path)}
                            />
                        )
                    )
                }
            </div>
            <Footer/>
        </main>
    )
}

export default PaymentMethods
